var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 102,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFBF48",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 5.406 88.4 8.077c-2.512-4.24-6.248-7.047-10.427-7.047-4.179 0-7.856 2.766-10.266 7.047C49.847 5.452 12.96 0 11.875 0A4.295 4.295 0 0 0 8.28 2.02C7.676 3.11.444 16.86.243 17.183c-.17.48-.252.986-.243 1.495C0 21.065 1.927 23 4.301 23a7.536 7.536 0 0 0 1.206-.101l59.728-7.774a25.813 25.813 0 0 0-.421 4.543 77.14 77.14 0 0 1 26.318 0c0-1.483-.134-2.963-.402-4.422 5.186.768 11.573 1.713 18.107 2.675M145.467 36.06a4.292 4.292 0 0 0 4.087-.691c.953-.852 12.533-11.48 12.834-11.719.357-.395.634-.857.816-1.359a4.42 4.42 0 0 0-.171-3.341 4.27 4.27 0 0 0-2.456-2.214 10.35 10.35 0 0 0-1.059-.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.518 16.35-41.16-9.13-4.387 12.054 31.612 16.86M112 92.673c.045-25.717-9.66-50.478-27.128-69.209a74.661 74.661 0 0 0-16.624 0C50.736 42.176 40.987 66.94 41 92.674c0 2.462.1 4.904.26 7.326 11.71-.35 23.46-.518 35.25-.505 11.79.014 23.526.182 35.21.505.18-2.422.28-4.864.28-7.327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 24c19.728 20.494 30.851 47.93 31.036 76.552 10.119.352 20.204.832 30.255 1.441a2.508 2.508 0 0 0 1.942-.715 2.576 2.576 0 0 0 .765-1.945C154.042 62.014 127.293 30.528 91 24zM64 24C27.708 30.528.96 62.014.003 99.332c-.037.73.24 1.442.758 1.951.518.51 1.229.768 1.949.709 10.038-.61 20.123-1.09 30.254-1.442C33.141 71.928 44.266 44.49 64 24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsiError);
export default __webpack_public_path__ + "static/media/bsi-error.8d65d5375f86de929d61f4813caff66b.svg";
export { ForwardRef as ReactComponent };